module.exports = __webpack_public_path__ + "media/images/sound-issue-054c680fb1a5f961900d4d67cae6eb9d.svg";